import Type from "@/model/types/Type";

const type = {
    FULL: 1,
/*    FULL_NOT_SEPARATOR: 2,*/
    NOT_ENVIRONMENT: 3,
    BASIC: 4,
}

const list = [
    {
        value: type.BASIC,
        text: "Legenda básica",
    },
    {
        value: type.FULL,
        text: "Nome + detalhe do ambiente",
    },
    {
        value: type.NOT_ENVIRONMENT,
        text: "Somente detalhes",
    },
/*    {
        value: type.FULL_NOT_SEPARATOR,
        text: "Completo, porém com menos separadores",
    },*/


]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}